import { FieldFunctionOptions } from '@apollo/client';

import { NotificationsQuery } from '../../types/api.graphql';

type NotificationsType = NotificationsQuery['notifications'];

export const mergeNotificationsCache = (
  existing: NotificationsType = undefined,
  incoming: NotificationsType,
  { readField }: FieldFunctionOptions,
) => {
  if (!incoming?.nodes) {
    return {};
  }
  const existingNodes = existing?.nodes || [];

  const newNodes = incoming?.nodes?.filter(
    (node: any) =>
      !existingNodes.find(
        (oldNode: any) => readField<string>('id', node)?.toString() === readField<string>('id', oldNode)?.toString(),
      ),
  );

  if (newNodes.length === 1) {
    // If there is only one item without pageInfo
    // we can consider it is a new notification comming from a subscription
    // so we added it to the top of the list
    return {
      ...existing,
      ...incoming,
      nodes: [...newNodes, ...existingNodes],
      pageInfo: incoming.pageInfo,
    };
  }

  const newData = {
    ...existing,
    ...incoming,
    nodes: [...existingNodes, ...newNodes],
    pageInfo: incoming.pageInfo,
  };
  return newData;
};
